import styled from '@emotion/styled'

import { LIST_SIZE } from '@/blocks/constants'
import { builderLightText } from '@/blocks/utils'
import { BodyM, HeadingL, HeadingS, type TypographyColorModifier } from '@/components/Typography'
import { withContainer } from '@/hocs/withContainer'

import type { TitleProps } from '@/models'

import ArticlesList from './ArticlesList'
import type { PremiumArticleCard } from './types'

const ArticlesStyles = styled.p`
  .articles__subtitle {
    margin: 1rem 0 2rem;
    font-size: 1.5rem;
  }
`
export interface ArticlesGalleryBlockProps {
  cards?: PremiumArticleCard[]
  title?: TitleProps
  subtitle?: TitleProps
  size: 'm' | 'l'
  colorModifier?: TypographyColorModifier
}

const ArticlesGalleryBlock = ({
  cards,
  title,
  subtitle,
  size,
  colorModifier,
}: ArticlesGalleryBlockProps) => {
  const TitleComponent = size === LIST_SIZE.lg ? HeadingL : HeadingS
  const lightText = builderLightText(colorModifier)

  return (
    <div>
      {title && title.text && (
        <TitleComponent className="eu-sm-1" tag={title.tag || 'h3'} light={lightText}>
          {title.text}
        </TitleComponent>
      )}
      <ArticlesStyles>
        {subtitle && subtitle.text && (
          <BodyM className="articles__subtitle" tag={subtitle.tag || 'p'} light={lightText}>
            {subtitle.text}
          </BodyM>
        )}
      </ArticlesStyles>
      <ArticlesList cards={cards} />
    </div>
  )
}

export default withContainer(ArticlesGalleryBlock, { contentClassName: 'eu-sp-m' })
